import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'

import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationCustomerCreateRequest, ConfigurationCustomerPatchInBatchRequest, ConfigurationCustomerResponse, ConfigurationCustomerVerifyRulesRequest } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'

class ConfigurationLocalAccountingBillableCustomerService {
    async create(laboratoryId: number, request: ConfigurationCustomerCreateRequest): Promise<ConfigurationCustomerResponse> {
        const response = await axios.post<ConfigurationCustomerResponse>(
            `/configuration/laboratories/${laboratoryId}/customers`,
            request
        )
        return response.data
    }

    async verifyRules(laboratoryId: number, request: ConfigurationCustomerVerifyRulesRequest): Promise<ConfigurationCustomerResponse[]> {
        const response = await axios.post<ConfigurationCustomerResponse[]>(
            `/configuration/laboratories/${laboratoryId}/customers/verifyRules`,
            request
        )
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationCustomerResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationCustomerResponse>>(
            `/configuration/laboratories/${laboratoryId}/customers`,
            { ...filterModel },
            { params }
        )
        return response.data
    }

    async get(laboratoryId: number, customerId: number): Promise<ConfigurationCustomerResponse> {
        const response = await axios.get<ConfigurationCustomerResponse>(
            `/configuration/laboratories/${laboratoryId}/customers/${customerId}`
        )
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(
            `/configuration/laboratories/${laboratoryId}/customers/batch`, { data: request }
        )
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationCustomerPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(
            `/configuration/laboratories/${laboratoryId}/customers/batch`,
            request
        )
        return response.data
    }
}

export const configurationLocalAccountingBillableCustomerService = new ConfigurationLocalAccountingBillableCustomerService()
